import React, { PropsWithChildren } from 'react';

import { HTTP_STATUS } from '@/api/ErrorCode.model.ts';
import { FullPageSpinner } from '@/components/ui/fullPageSpinner/FullPageSpinner.comp.tsx';
import { BootstrapErrorState } from '@/contexts/userContext/BootstrapErrorState.comp.tsx';
import { UserContext } from '@/contexts/userContext/User.context.ts';
import { getBootstrapErrorView } from '@/contexts/userContext/util/getBootstrapErrorView.util.ts';
import { useGetCurrentUser } from '@/contexts/userContext/util/useGetCurrentUser.util.ts';
import MaintenancePage from '@/views/maintenancePage/MaintenancePage.view.tsx';

export const UserContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { currentUser, error, isErrorGettingCurrentUser, isGettingCurrentUser } =
    useGetCurrentUser();

  if (isGettingCurrentUser) {
    return <FullPageSpinner />;
  }

  if (isErrorGettingCurrentUser && error.status === HTTP_STATUS.SERVICE_UNAVAILABLE) {
    return <MaintenancePage />;
  }

  if (isErrorGettingCurrentUser || !currentUser) {
    return <BootstrapErrorState view={getBootstrapErrorView(error)} />;
  }

  if (!currentUser.permissions || currentUser.permissions.length === 0) {
    return <BootstrapErrorState view="notAuthorized" />;
  }

  return <UserContext value={currentUser}>{children}</UserContext>;
};
